module.exports = __webpack_public_path__ + "static/media/cyberessentials_certification_vector_blue.bb016731.png";